import {SomService} from "../../api/somService";
import {toastError, toastSuccess} from "../../shared/components/toast/Toast";
import * as actionTypes from "../actionTypes";
import {store} from "../store";
import {fetchDataAttive, simSetSelectedRowSchedaTehnica} from "../sim/actions";

export const callBarringList = (integrationId, userId, iccIdList, numbersBlockedList) => {
    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "loading", value: true})
        SomService.callBarringList(integrationId, userId, iccIdList, numbersBlockedList)
            .then(() => {
                toastSuccess("Operazione completata");
            })
            .catch(e => {
                console.log(e);
                toastError("Operazione fallita.")
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "loading", value: false})
            })
    }
}

export const getEnablingClasses = (integrationId, simList) => {
    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_ENABLING_CLASSES, loading: true});
        SomService.getEnablingClasses(integrationId, simList)
            .then(res => {
                dispatch({
                    type: actionTypes.SET_ENABLING_CLASSES,
                    data: res.data.enablingClassList
                })
            })
            .catch(e => {
                console.error(e.response.data.message)
                toastError(e.response.data.message)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_ENABLING_CLASSES, loading: false});
            })
    }
}

export const clearEnablingClasses = () => {
    return ({
        type: actionTypes.CLEAR_ENABLING_CLASSES
    })
}

export const modifyEnablingClass = (integrationId, userId, simList, enablingClass) => {
    SomService.modifyEnablingClass(integrationId, userId, simList, enablingClass).then(() => {
        toastSuccess("Operazione completata");
    }).catch(e => {
        console.log(e);
        toastError("Operazione fallita.")
    })
}

export const changeEnablingClassCheckbox = (id) => {
    let enablingClassList = store.getState().serviceRequestReducer.enablingClasses
    let modifiedEnablingClasses = enablingClassList.filter(ec => ec.id !== id)
        .map(ec => ({
            ...ec,
            isInEverySim: false,
            isChecked: false
        }))
    const indx = enablingClassList.findIndex(ec => ec.id === id)
    const selectedClass = {
        ...enablingClassList[indx], isInEverySim: true,
        isChecked: true
    }
    modifiedEnablingClasses.push(selectedClass)
    modifiedEnablingClasses.sort((a, b) =>
        a.label.localeCompare(b.label));

    return ({
        type: actionTypes.CHANGE_SELECTED_ENABLED_CLASS,
        data: modifiedEnablingClasses
    })
}

export const getEnablingData = (integrationId, simList) => {
    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_ENABLING_DATA, loading: true});
        SomService.getEnablingData(integrationId, simList)
            .then((res) => {
                dispatch({
                    type: actionTypes.SET_ENABLING_DATA,
                    data: res.data.enableDataList
                })
            })
            .catch((e) => {
                dispatch(clearEnablingData())
                console.error(e.response.data.message)
                toastError(e.response.data.message)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_ENABLING_DATA, loading: false});
            })
    }
}

export const clearEnablingData = () => {
    return ({
        type: actionTypes.CLEAR_ENABLING_DATA
    })
}

export const changeEnablingDataRadioButton = (id) => {
    let enablingDataList = store.getState().serviceRequestReducer.enablingData;
    let newEnablingDataList = [];
    enablingDataList.forEach(ed => {
        if (ed.id !== id) {
            newEnablingDataList.push({...ed, isInEverySim: false, isChecked: false})
        } else {
            newEnablingDataList.push({...ed, isInEverySim: true, isChecked: true})
        }
    })

    return ({
        type: actionTypes.CHANGE_SELECTED_ENABLED_DATA,
        data: newEnablingDataList
    })
}

export const modifyEnablingData = (integrationId, userId, simList, enablingData, fetchScheda) => {
    return dispatch => {
        dispatch({type: actionTypes.SET_MODIFY_ABILITAZIONE_DATI_PARAMS, name: "buttonLoading", payload: true})
        SomService.modifyEnablingData(integrationId, userId, simList, enablingData)
            .then(() => {
                toastSuccess("Operazione completata con successo. Aggiorna la pagina tra qualche secondo per verificare l'avvenuto cambiamento.");
                dispatch({type: actionTypes.SET_MODIFY_ABILITAZIONE_DATI_PARAMS, name: "error", payload: false})
                if (fetchScheda)
                    dispatch(simSetSelectedRowSchedaTehnica(simList[0].iccId))
            })
            .catch((e) => {
                console.log(e);
                toastError("Operazione fallita.")
                dispatch({type: actionTypes.SET_MODIFY_ABILITAZIONE_DATI_PARAMS, name: "error", payload: true})
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_MODIFY_ABILITAZIONE_DATI_PARAMS, name: "buttonLoading", payload: false})
            })
    }
}

export const modifyAllowList = (toRemoveIccIdList, toAddIccIdList, sim) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const userId = store.getState().authReducer.userClaims.uid ?? "test";

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "loading", value: true})
        dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "error", value: false})
        SomService.modifyAllowList(integrationId, userId, toRemoveIccIdList, toAddIccIdList, sim)
            .then(() => {
                toastSuccess('Operazione completata con successo')
            })
            .catch((e) => {
                console.error(e.response.data.message)
                toastError(e.response.data.message)
                dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "error", value: true})
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "loading", value: false})
            })
    }
}

export const resetSimPassword = (simList, smsMobilePhone) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const userId = store.getState().authReducer.userClaims.uid;

    return dispatch => {
        dispatch({type: actionTypes.SET_SIM_RESET_PASSWORD_VALUES, name: "buttonLoading", payload: true})
        SomService.resetSimPassword(integrationId, userId, simList, smsMobilePhone)
            .then((res) => {
                if (res.data.allPassed) {
                    dispatch({type: actionTypes.SET_SIM_RESET_PASSWORD_VALUES, name: "error", payload: false})
                    toastSuccess(`Operazione eseguita con successo! Si prega di attendere qualche minuto la ricezione della notifica SMS sul numero indicato.`)
                } else {
                    const numberCompleted = simList.length - res.data.numberFailed
                    if (numberCompleted === 0) {
                        dispatch({type: actionTypes.SET_SIM_RESET_PASSWORD_VALUES, name: "error", payload: true})
                        toastError("Operazione non riuscita per tutte le SIM selezionate.")
                    } else {
                        dispatch({type: actionTypes.SET_SIM_RESET_PASSWORD_VALUES, name: "error", payload: false})
                        toastSuccess(`Operazione completata per ${numberCompleted} SIM/s.`)
                        toastError(`Operazione fallita per ${res.data.numberFailed} SIM/s.`)
                    }
                }
            })
            .catch(e => {
                dispatch({type: actionTypes.SET_SIM_RESET_PASSWORD_VALUES, name: "error", payload: true})
                console.error(e.response.data.message)
                toastError(e.response.data.message)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_SIM_RESET_PASSWORD_VALUES, name: "buttonLoading", payload: false})
            })
    }
}

export const changeSimIpAddress = (ipAddress, iccId, loadSchedaTecnica) => {
    const simAttiveState = store.getState().simReducer.attive
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const userId = store.getState().authReducer.userClaims.uid;

    const changeIpDto = {
        userId: userId,
        integrationId: integrationId,
        ipAddress: ipAddress,
        iccId: iccId
    }
    return dispatch => {
        dispatch({type: actionTypes.SET_CHANGE_IP_VALUES, name: "loading", payload: true})
        SomService.changeIpAddress(changeIpDto)
            .then(() => {
                if (loadSchedaTecnica)
                    dispatch(simSetSelectedRowSchedaTehnica(iccId))
                toastSuccess("Indirizzo IP modificato correttamente")
                dispatch(fetchDataAttive(simAttiveState.page, simAttiveState.rowsPerPage))
                dispatch({type: actionTypes.SET_CHANGE_IP_VALUES, name: "error", payload: false})
            })
            .catch(e => {
                dispatch({type: actionTypes.SET_CHANGE_IP_VALUES, name: "error", payload: true})
                console.error(e.response.data.message)
                toastError(e.response.data.message)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_CHANGE_IP_VALUES, name: "loading", payload: false})
            })
    }
}

export const changeApn = (apnForm, iccId) => {
    const simAttiveState = store.getState().simReducer.attive
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const userId = store.getState().authReducer.userClaims.uid;

    const changeApnDto = {
        userId: userId,
        integrationId: integrationId,
        iccId: iccId,
        apnType: apnForm.apnType,
        apnName: apnForm.apnName,
        vrfName: apnForm.vrfName
    }
    return dispatch => {
        dispatch({type: actionTypes.SET_CHANGE_APN_VALUES, name: "loading", payload: true})
        SomService.changeApn(changeApnDto)
            .then(() => {
                dispatch(fetchDataAttive(simAttiveState.page, simAttiveState.rowsPerPage))
                dispatch({type: actionTypes.SET_CHANGE_APN_VALUES, name: "error", payload: false})
            })
            .catch(e => {
                console.log(e)
                dispatch({type: actionTypes.SET_CHANGE_APN_VALUES, name: "error", payload: true})
                toastError("Si è verificato un errore durante la modifica dell'APN")
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_CHANGE_APN_VALUES, name: "loading", payload: false})
            })
    }
}

export const fetchModifyApnOptions = (iccId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return dispatch => {
        dispatch({type: actionTypes.SET_CHANGE_APN_VALUES, name: "fetchLoading", payload: true})
        SomService.fetchModifyApnOptions(integrationId, iccId)
            .then(res => {
                dispatch({
                    type: actionTypes.SET_CHANGE_APN_SELECT_DATA,
                    payload: res.data
                })
            })
            .catch(e => {
                dispatch({
                    type: actionTypes.SET_CHANGE_APN_SELECT_DATA,
                    payload: {
                        apnOptions: [],
                        condivisoApnNames: [],
                        condivisoVrfNames: [],
                        dedicatoApnNames: []
                    }
                })
                console.error(e.response.data.message);
                toastError(e.response.data.message);
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_CHANGE_APN_VALUES, name: "fetchLoading", payload: false})
            })
    }
}

export const changeRamGroup = (ramGroup, iccIdList) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    const userId = store.getState().authReducer.userClaims.uid

    const changeRamGroupDto = {
        userId: userId,
        integrationId: integrationId,
        iccIdList: iccIdList,
        ramGroup: ramGroup
    }

    return dispatch => {
        dispatch({type: actionTypes.SET_CHANGE_RAM_PARAMS, name: "buttonLoading", payload: true})
        SomService.changeRamGroup(changeRamGroupDto)
            .then(() => {
                dispatch({type: actionTypes.SET_CHANGE_RAM_PARAMS, name: "error", payload: false})
                toastSuccess("Operazione completata con successo! Attendi qualche secondo e ricarica la " +
                    "pagina della SIM per aggiornare la vista sul portale")
            })
            .catch(e => {
                dispatch({type: actionTypes.SET_CHANGE_RAM_PARAMS, name: "error", payload: true})
                toastError("Cambio della RAM di gruppo non riuscito per alcune SIM")
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_CHANGE_RAM_PARAMS, name: "buttonLoading", payload: false})
            })
    }
}